import * as actionTypes from '../actions/authActions';

const initialState = {
    name: null,
    imgsrc: null,
    empId: null,
    userId: null,
    department: null,
    teams:null,
    designation: null,
    authToken: null,
    isLoggedIn: false,
    employeeCreatedAt: null,
    emails: [],
    pushEnabled: null,
    filters: null,
};
const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOGIN:
            return {
                ...state,
                name: action.name,
                imgsrc: action.imgsrc,
                userId: action.userId,
                empId: action.empId,
                department: action.department,
                teams:action.teams,
                designation: action.designation,
                authToken: action.token,
                isLoggedIn: true,
                employeeCreatedAt: action.employeeCreatedAt,
                emails: action.employeeEmails,
                pushEnabled: action.pushEnabled,
                filters: action.filters
            }
        case actionTypes.LOGOUT:
            return {
                ...state,
                name: null,
                userId: null,
                imgsrc: null,
                empId: null,
                department: null,
                teams:null,
                designation: null,
                authToken: null,
                isLoggedIn: false,
                employeeCreatedAt: null,
                emails: [],
                pushEnabled: null,
                filters: null
            }
        default:
            return state;
    }
};
export default authReducer;
